import { Component, OnInit } from '@angular/core';
import { AppService } from '../../../app.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-about-popup',
  templateUrl: './about-popup.component.html',
  styleUrls: ['./about-popup.component.scss']
})
export class GETAboutPopupComponent implements OnInit {
  SiteCode: number;
  CurrentYear: number;

  constructor(private appService: AppService,
    public dialogRef: MatDialogRef<GETAboutPopupComponent>,
    ) { }

  ngOnInit() {
    this.appService.getSiteCode().subscribe(r => {
      this.SiteCode = r;
    });
    this.CurrentYear = new Date().getFullYear();
  }
  onNoClick() {
    this.dialogRef.close();
  }
}
